import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const spacex: GetCustomerCopyFunc = () => {
  return {
    displaySessionLimit: false, // This is a deliberate choice on behalf of SpaceX even though they have session limits
  }
}
